export default __webpack_public_path__ + "static/media/done.f7d4a927.jpg";